import { Fragment } from 'react'
import { flowRight as compose } from 'lodash'

import withPage from '@/lib/page/withPage'
import withTermsNPrivacyLayout from '@/components/Layout/TermsAndPrivacy'

import { TERMS_OF_USE } from '@/features/term-privacy/constants'
import { renderTemplate } from '@/features/term-privacy/utils'
import { NextSeo } from 'next-seo'

function Terms() {
  return (
    <Fragment>
      <NextSeo title="ข้อกำหนดและเงื่อนไขการใช้งาน" />

      <h1>ข้อกำหนดและเงื่อนไขการใช้งาน</h1>
      <p>
        ข้อกำหนดและเงื่อนไขในการใช้งานฉบับนี้ (&quot;ข้อกำหนดและเงื่อนไขฯ&quot;
        หรือ &quot;สัญญา&quot;) เป็นข้อตกลงระหว่าง PDPA Pro (&quot;บริษัท
        เอ็นเดต้าธอธ จำกัด&quot; หรือ &quot;เรา&quot;) และท่าน
        (&quot;ผู้ใช้&quot; หรือ &quot;ท่าน&quot;)
        สัญญาฉบับนี้ได้กำหนดข้อกำหนดและเงื่อนไขทั่วไปสำหรับการใช้งาน PDPA Pro
        ผลิตภัณฑ์หรือบริการ และการเข้าร่วมกิจกรรมที่เกี่ยวข้องกับ PDPA Pro ใด ๆ
        ก็ตามของท่าน (เรียกรวมกันว่า &quot;เว็บไซต์&quot; หรือ
        &quot;บริการ&quot;)
      </p>

      {renderTemplate(TERMS_OF_USE.subMenus)}

      <div id="endTermsContent" css={{ marginTop: 48 }}>
        เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 25 มกราคม พ.ศ. 2565
      </div>
    </Fragment>
  )
}

export default compose(withPage(), withTermsNPrivacyLayout)(Terms)
